export const IOrderingHours = "IOrderingHours";
